// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__217Iy","actions":"GroupTable_actions__3sQdQ","deleteModalFooter":"GroupTable_deleteModalFooter__tuQYM"};